<pane-card>
    <card-header ngProjectAs="card-header">Edit Project</card-header>

    <card-content ngProjectAs="card-main-content">
        @if (details(); as details) {
            <project-details
                [project]="details"
                [programs]="programs()"
                class="flex-grow-1" />
        }
    </card-content>

    <card-content #cardBottom ngProjectAs="card-bottom-content">
        <form-dialog-standard-submit-buttons
            footer
            style="position: sticky"
            class="mt-auto"
            actionButtonName="Save"
            closeBtnName="Cancel"
            [isBusy]="submitCommand.isBusy() || details()?.isPending()"
            [isValid]="submitCommand.isValid()"
            (cancel)="cancelCommand.execute()"
            (submit)="submitCommand.execute()" />
    </card-content>
</pane-card>
